$('.js-scroll-below').on('click', function ScrollBelow() {
  const $main = $('html, body');
  const $heroSection = $(this).parent();
  const heroSectionTop = $heroSection.offset().top;
  const heroSectionHeight = $heroSection.outerHeight();
  const headerCollapsedHeight = 34;
  let stickyNavHeight = 0;

  if ($heroSection.hasClass('sticky-nav--enabled') && $('#resort-menu').length) {
    stickyNavHeight = $('#resort-menu').outerHeight();
  }

  if ($('#resort-menu').length && $('#resort-menu').hasClass('middle-position')) {
    stickyNavHeight = 0;
  }

  const scrollHere = heroSectionTop + heroSectionHeight - headerCollapsedHeight - stickyNavHeight;

  $main.animate({
    scrollTop: scrollHere
  }, 1000);
});
